var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ERRORTYPE } from '../global';
import { Module, VuexModule, Mutation, Action } from 'vuex-class-modules';
import { ToastMessage } from '../models/toastError.model';
let ToastModule = class ToastModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.toastError = null;
        this.toastClicked = false;
    }
    enterToastError(message) {
        this.toastError = message;
    }
    enterToastClicked(bool) {
        this.toastClicked = bool;
    }
    setToastError(message) {
        return __awaiter(this, void 0, void 0, function* () {
            this.enterToastError(message);
        });
    }
    toastIsClicked() {
        return __awaiter(this, void 0, void 0, function* () {
            this.enterToastClicked(!this.toastClicked);
        });
    }
    createAndPushToast(title, text, timeout, type) {
        this.enterToastError(this.createMessage(text, title, timeout, type));
    }
    pushError(message) {
        this.enterToastError(this.createMessage(message));
    }
    createMessage(message, title = 'Erreur', timeout = true, type = ERRORTYPE.DANGER) {
        return {
            actionLibelle: message,
            label: title,
            timeout: timeout,
            type: type
        };
    }
    get toastErrorMessage() {
        return this.toastError;
    }
    get toastClickedState() {
        return this.toastClicked;
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ToastMessage]),
    __metadata("design:returntype", void 0)
], ToastModule.prototype, "enterToastError", null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ToastModule.prototype, "enterToastClicked", null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [ToastMessage]),
    __metadata("design:returntype", Promise)
], ToastModule.prototype, "setToastError", null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], ToastModule.prototype, "toastIsClicked", null);
ToastModule = __decorate([
    Module
], ToastModule);
export { ToastModule };
